'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgMission(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M2 10.965a.531.531 0 00.447.529l.084.006H13.46a.536.536 0 100-1.071H2.54a.54.54 0 00-.54.536zm11.46 1.607a.536.536 0 01.079 1.065l-.08.006H2.527A.53.53 0 012 13.108a.54.54 0 01.461-.53l.08-.006H13.46zM12.289 2.5c.947 0 1.714.768 1.714 1.714v3.43c0 .946-.767 1.713-1.714 1.713H3.717a1.714 1.714 0 01-1.714-1.714V4.214c0-.946.767-1.714 1.714-1.714h8.572z", fill: "currentColor" }))));
}

module.exports = SvgMission;
//# sourceMappingURL=Mission.js.map
